<script>
export default {
  name: "TabNavigation",
  props: {
    tab1Label: { // Want this to be dynamic with n tabs, don't have time rn
      type: String,
      required: false
    },
    tab2Label: {
      type: String,
      required: false
    },
    hideTabs: {
      type: Boolean, // Hides the default header controls if. Use the switchTab method to control from parent
      default: false
    },
    reverseAnimation: { // Reverses the where the tabs slide in from
      type: Boolean,
      default: false
    }

  },
  setup() {

    return {

    };
  },
  data() {
    return {
      activeTab: 'tab-1',
      previousTab: null
    };
  },

  methods: {
    switchTab(tab) {
      this.previousTab = this.activeTab;
      this.activeTab = tab;
    },
    beforeEnter(el) {
      if(this.reverseAnimation) {
        el.style.transform = `translateX(${this.previousTab === 'tab-1' && this.activeTab === 'tab-2' ? '-100%' : '100%'})`;
      }else {
        el.style.transform = `translateX(${this.previousTab === 'tab-1' && this.activeTab === 'tab-2' ? '100%' : '-100%'})`;
      }
    },

    enter(el, done) {
      // Trigger reflow
      el.offsetWidth; // eslint-disable-line  @typescript-eslint/no-unused-expressions
      el.style.transition = 'transform 0.3s ease-in-out';
      el.style.transform = 'translateX(0)';
      done();
    },

    leave(el, done) {
      el.style.transition = 'transform 0.3s ease-in-out';
      if(this.reverseAnimation) {
        el.style.transform = `translateX(${this.previousTab === 'tab-1' && this.activeTab === 'tab-2' ? '100%' : '-100%'})`;
      } else {
        el.style.transform = `translateX(${this.previousTab === 'tab-1' && this.activeTab === 'tab-2' ? '-100%' : '100%'})`;
      }
      done();
    }
  }
};
</script>

<template>
  <div class="overflow-hidden">
    <div class="min-h-[50vh] relative w-full mx-auto overflow-hidde text-xs">
      <!-- Tab headers -->
      <div
        v-if="!hideTabs"
        class="tab-container overflow-hidden flex sm:flex-row"
      >
        <button
          :class="{'active': activeTab === 'tab-1'}"
          class="tab-header transition-colors duration-300"
          @click="switchTab('tab-1')"
        >
          {{ tab1Label }}
        </button>
        <button
          :class="{'active': activeTab === 'tab-2'}"
          class="tab-header transition-colors duration-300"
          @click="switchTab('tab-2')"
        >
          {{ tab2Label }}
        </button>
      </div>
      <div class="overflow-hidden">
        <!-- Tab content with sliding animation -->
        <transition
          name="slide"
          @before-enter="beforeEnter"
          @enter="enter"
          @leave="leave"
        >
          <div
            :key="activeTab"
            class="tab-content"
          >
            <div
              v-if="activeTab === 'tab-1'"
              class="tab-pane"
            >
              <slot name="tab-1-content" />
            </div>
            <div
              v-if="activeTab === 'tab-2'"
              class="tab-pane"
            >
              <slot name="tab-2-content" />
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<style lang="scss">

.slide-enter-active, .slide-leave-active {
  transition: transform 0.3s ease-in-out;
}

.slide-enter, .slide-leave-to {
  transform: translateX(100%);
}

.slide-leave {
  transform: translateX(-100%);
}

@media screen and (max-width: 720px) {
  .tab-container {
    flex-direction: row;
    align-items: center;
  }
}

.tab-header {
  @apply flex-1 py-2 text-center;

  &.active {
    border-bottom: 2px solid #3a4473;
  }

}

</style>
